/**
 * Shared export column policy (PDF landscape readability).
 */

/** Max columns for landscape letter PDF exports */
export const PDF_EXPORT_MAX_COLUMNS = 10;

export const getPdfColumnLimitMessage = (count = PDF_EXPORT_MAX_COLUMNS) =>
  `PDF export supports at most ${count} columns for readable landscape layout. Deselect columns in Configure Export Columns or export to Excel for full detail.`;

export const validatePdfExportColumnCount = (selectedCount) => {
  if (selectedCount <= PDF_EXPORT_MAX_COLUMNS) {
    return { ok: true };
  }
  return {
    ok: false,
    message: getPdfColumnLimitMessage(),
  };
};
